import PedidoCuentaDelete from './PedidoCuentaDelete'
export {PedidoCuentaDelete}
export default PedidoCuentaDelete
